import React,{useRef,useEffect} from 'react'
import logo from "../assests/logo.png"
import LoadingSpinner from './client/LoadingSpinner'
import gsap from "gsap"

const SplashScreen = () => {
  const shapeRef = useRef(null);
  useEffect(() => {
    const tl = gsap.timeline({ ease: "easeIn" });

    tl.to(shapeRef.current, { duration: 0.8, x: 45, y: 0,rotate:45 })  // Right
      .to(shapeRef.current, { duration: 0.8, x:45, y: 45,rotate:45 }) // Bottom
      .to(shapeRef.current, { duration: 0.8, x: 0, y: 45,rotate:45  }) // Left
      .to(shapeRef.current, { duration: 0.8, x: 0, y: -49,rotate:45,
        onComplete: () => { 
        if(shapeRef?.current?.style?.display )
                shapeRef.current.style.display = "none"; 
      }  }) // Left



  }, []);


  return (
    <div  className='content_container bg-parimary'>
     <div className='w-100 h-100 d-flex justify-content-center align-items-center' > 
        <div className='d-flex position-relative overflow-hidden    flex-column gap-2' style={{width:'4rem',height:'4rem',borderRadius:'30%'}}>
          <div ref={shapeRef} className='position-absolute top-0 left-0  w-75 h-75 rounded-md ' style={{backgroundColor:'#e1d5fe'}}>

          </div>
          <img src={logo}  className='w-100 h-100 '   alt="" />
          {/* <div>
          <span className="spinner-border spinner-border-xxl w-full text-primary " />
          </div> */}
     
        </div>

     </div>

    </div>
  )
}

export default SplashScreen